// stickyHeaderManager.ts

const NAVBAR_HEIGHT = 112;

interface GridEntry {
  id: string;
  getContainerEl: () => HTMLElement | null;
  getScrollSourceEl: () => HTMLElement | null;
  getFrozenColumnsEnabled: () => boolean;
}

const registry = new Map<string, GridEntry>();
let currentStickyId: string | null = null;
let currentStickyEl: HTMLElement | null = null;
let currentScrollSourceEl: HTMLElement | null = null;
let currentFrozenColumnsEnabled = false;
let scrollListenerAttached = false;

// function syncHorizontalScroll(
//   stickyEl: HTMLElement,
//   containerEl: HTMLElement,
//   scrollSourceEl: HTMLElement,
// ) {
//   const clipWrapper = stickyEl.querySelector(
//     "[data-clip-wrapper]",
//   ) as HTMLElement;
//   const cloneTable = stickyEl.querySelector("table") as HTMLElement;
//   if (!cloneTable || !clipWrapper) return;

//   const scrollLeft = scrollSourceEl.scrollLeft;
//   cloneTable.style.transform = `translateX(-${scrollLeft}px)`;

//   const cloneThs = cloneTable.querySelectorAll("th") as NodeListOf<HTMLElement>;
//   cloneThs.forEach((cloneTh) => {
//     cloneTh.style.transform = "";
//     cloneTh.style.borderLeft = "1px solid #e5e7eb";
//     cloneTh.style.borderTop = "1px solid #e5e7eb";
//     cloneTh.style.borderBottom = "2px solid #e5e7eb";
//   });
// }

function syncHorizontalScroll(
  stickyEl: HTMLElement,
  containerEl: HTMLElement,
  scrollSourceEl: HTMLElement,
  frozenColumnsEnabled: boolean, // NEW param
) {
  const clipWrapper = stickyEl.querySelector(
    "[data-clip-wrapper]",
  ) as HTMLElement;
  const cloneTable = stickyEl.querySelector("table") as HTMLElement;
  if (!cloneTable || !clipWrapper) return;

  const scrollLeft = scrollSourceEl.scrollLeft;
  cloneTable.style.transform = `translateX(-${scrollLeft}px)`;

  const cloneThs = cloneTable.querySelectorAll("th") as NodeListOf<HTMLElement>;
  const originalThs = containerEl.querySelectorAll(
    ".p-datatable-thead th",
  ) as NodeListOf<HTMLElement>;

  cloneThs.forEach((cloneTh, i) => {
    const originalTh = originalThs[i] as HTMLElement;
    if (!originalTh) return;

    // const isFrozen =
    //   frozenColumnsEnabled &&
    //   (originalTh.classList.contains("p-frozen-column") ||
    //     originalTh.classList.contains("selectionHeader"));
    const isFrozen =
      frozenColumnsEnabled &&
      (originalTh.classList.contains("sticky-frozen-th") ||
        originalTh.classList.contains("selectionHeader"));

    if (isFrozen) {
      // Counter-translate frozen columns — pin them back in place
      cloneTh.style.transform = `translateX(${scrollLeft}px)`;
      cloneTh.style.borderLeft = "1px solid #e5e7eb";
      cloneTh.style.borderTop = "1px solid #e5e7eb";
      cloneTh.style.borderBottom = "2px solid #e5e7eb";
      cloneTh.style.backgroundColor = "#ffffff";
      cloneTh.style.zIndex = "20";
      cloneTh.style.position = "sticky";
    } else {
      cloneTh.style.transform = "";
      cloneTh.style.borderLeft = "1px solid #e5e7eb";
      cloneTh.style.borderTop = "1px solid #e5e7eb";
      cloneTh.style.borderBottom = "2px solid #e5e7eb";
    }
  });
}

function createStickyHeader(
  containerEl: HTMLElement,
  scrollSourceEl: HTMLElement,
  frozenColumnsEnabled: boolean,
): HTMLElement | null {
  const originalTable = containerEl.querySelector(
    ".p-datatable-table",
  ) as HTMLElement;
  const originalThead = containerEl.querySelector(
    ".p-datatable-thead",
  ) as HTMLElement;
  if (!originalTable || !originalThead || !scrollSourceEl) return null;

  document.querySelector("[data-sticky-table]")?.remove();

  //   const containerRect = containerEl.getBoundingClientRect();

  const viewportRect = scrollSourceEl.getBoundingClientRect();

  const fixedContainer = document.createElement("div");
  fixedContainer.setAttribute("data-sticky-table", "true");
  fixedContainer.style.cssText = `
	position: fixed;
	top: ${NAVBAR_HEIGHT}px;
	left: ${viewportRect.left}px;
	width: ${viewportRect.width}px;
	overflow: hidden;
	z-index: 999;
	background: #ffffff;
`;

  const cloneTable = document.createElement("table");
  cloneTable.className = "p-datatable-table";

  const clonedThead = originalThead.cloneNode(true) as HTMLElement;
  cloneTable.appendChild(clonedThead);

  cloneTable.style.cssText = `
		table-layout: fixed;
		width: ${originalTable.offsetWidth}px;
		margin: 0;
		border-collapse: separate;
		border-spacing: 0;
		transform: translateX(-${scrollSourceEl.scrollLeft}px);
	`;

  cloneTable.querySelector(".p-datatable-tbody")?.remove();
  cloneTable.querySelector(".p-datatable-tfoot")?.remove();

  const originalThs = originalThead.querySelectorAll(
    "th",
  ) as NodeListOf<HTMLElement>;
  const cloneThs = cloneTable.querySelectorAll("th") as NodeListOf<HTMLElement>;

  originalThs.forEach((th, i) => {
    const cloneTh = cloneThs[i] as HTMLElement;
    if (!cloneTh) return;

    const width = th.getBoundingClientRect().width;
    const computedStyle = window.getComputedStyle(th);
    const computedBg = computedStyle.backgroundColor;

    // const isFrozen =
    //   frozenColumnsEnabled &&
    //   (th.classList.contains("p-frozen-column") ||
    //     th.classList.contains("selectionHeader"));
    const isFrozen =
      frozenColumnsEnabled &&
      (th.classList.contains("sticky-frozen-th") ||
        th.classList.contains("selectionHeader"));

    cloneTh.style.width = `${width}px`;
    cloneTh.style.minWidth = `${width}px`;
    cloneTh.style.maxWidth = `${width}px`;
    cloneTh.style.borderTop = "1px solid #e5e7eb";
    cloneTh.style.borderBottom = "2px solid #e5e7eb";
    cloneTh.style.borderLeft = "1px solid #e5e7eb";
    cloneTh.style.boxSizing = "border-box";
    cloneTh.style.backgroundColor =
      computedBg && computedBg !== "rgba(0, 0, 0, 0)" ? computedBg : "#ffffff";
    cloneTh.style.color = computedStyle.color || "#0091b3";
    cloneTh.style.fontWeight = "bold";
    cloneTh.style.fontSize = computedStyle.fontSize || "0.9rem";
    cloneTh.style.fontFamily = computedStyle.fontFamily;
    cloneTh.style.textAlign = "left";
    cloneTh.style.padding = "6px";
    cloneTh.style.whiteSpace = "nowrap";
    cloneTh.style.overflow = "hidden";
    cloneTh.style.textOverflow = "ellipsis";
    cloneTh.style.verticalAlign = "middle";

    if (isFrozen) {
      cloneTh.style.position = "sticky";
      cloneTh.style.left = th.style.left || "0px";
      cloneTh.style.zIndex = "20";
      cloneTh.style.backgroundColor = "#ffffff";
    } else {
      cloneTh.style.position = "";
      cloneTh.style.left = "";
      cloneTh.style.zIndex = "1";
    }

    const headerContent = cloneTh.querySelector(
      ".p-column-header-content",
    ) as HTMLElement;
    if (headerContent) {
      headerContent.style.display = "flex";
      headerContent.style.alignItems = "center";
      headerContent.style.color = computedStyle.color || "#0091b3";
      headerContent.style.fontWeight = "bold";
    }

    const titleSpan = cloneTh.querySelector(".p-column-title") as HTMLElement;
    if (titleSpan) {
      titleSpan.style.color = computedStyle.color;
      titleSpan.style.fontWeight = "bold";
      titleSpan.style.fontSize = computedStyle.fontSize || "0.9rem";
      titleSpan.style.whiteSpace = "nowrap";
      titleSpan.style.maxWidth = "120px";
      titleSpan.style.overflow = "hidden";
      titleSpan.style.textOverflow = "ellipsis";
    }
  });

  const cloneSelectionTh = cloneTable.querySelector(
    ".selectionHeader",
  ) as HTMLElement;
  if (cloneSelectionTh) {
    cloneSelectionTh.style.width = "35px";
    cloneSelectionTh.style.minWidth = "35px";
    cloneSelectionTh.style.maxWidth = "35px";
    cloneSelectionTh.style.textAlign = "center";
    cloneSelectionTh.style.padding = "0";

    if (frozenColumnsEnabled) {
      cloneSelectionTh.style.position = "sticky";
      cloneSelectionTh.style.left = "0px";
      cloneSelectionTh.style.zIndex = "30"; // above frozen data columns
    } else {
      cloneSelectionTh.style.position = "";
      cloneSelectionTh.style.left = "";
      cloneSelectionTh.style.zIndex = "1";
    }

    cloneSelectionTh.style.backgroundColor = "#ffffff";
    cloneSelectionTh.style.borderLeft = "1px solid #e5e7eb";
    cloneSelectionTh.style.borderTop = "1px solid #e5e7eb";
    cloneSelectionTh.style.borderBottom = "2px solid #e5e7eb";

    const headerContent = cloneSelectionTh.querySelector(
      ".p-column-header-content",
    ) as HTMLElement;
    if (headerContent) {
      headerContent.style.display = "flex";
      headerContent.style.justifyContent = "center";
      headerContent.style.alignItems = "center";
      headerContent.style.width = "100%";
      headerContent.style.height = "100%";
      headerContent.style.padding = "0";
    }

    cloneSelectionTh.querySelectorAll("*").forEach((el: any) => {
      el.style.pointerEvents = "none";
    });

    const overlay = document.createElement("div");
    overlay.style.cssText = `
			position: absolute;
			top: 0; left: 0;
			width: 100%; height: 100%;
			cursor: pointer;
			z-index: 30;
			background: transparent;
		`;

    overlay.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const originalInput = originalThead.querySelector(
        '.selectionHeader input[type="checkbox"]',
      ) as HTMLInputElement;
      if (originalInput) {
        originalInput.dispatchEvent(
          new MouseEvent("mousedown", {
            bubbles: true,
            cancelable: true,
            view: window,
          }),
        );
        originalInput.dispatchEvent(
          new MouseEvent("mouseup", {
            bubbles: true,
            cancelable: true,
            view: window,
          }),
        );
        originalInput.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          }),
        );
      }
      const originalBox = originalThead.querySelector(
        ".selectionHeader .p-checkbox-box",
      ) as HTMLElement;
      if (originalBox) {
        originalBox.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          }),
        );
      }
      const originalWrapper = originalThead.querySelector(
        ".selectionHeader .p-checkbox",
      ) as HTMLElement;
      if (originalWrapper) {
        originalWrapper.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          }),
        );
      }
    });

    cloneSelectionTh.appendChild(overlay);
  }

  const clipWrapper = document.createElement("div");
  clipWrapper.setAttribute("data-clip-wrapper", "true");
  clipWrapper.style.cssText = `
		position: relative;
		overflow: hidden;
		width: 100%;
	`;
  clipWrapper.appendChild(cloneTable);
  fixedContainer.appendChild(clipWrapper);
  document.body.appendChild(fixedContainer);

  originalThead.style.visibility = "hidden";
  originalThead.style.opacity = "0";
  originalThead.style.pointerEvents = "none";

  const cloneCheckboxWrapper = cloneTable.querySelector(
    ".selectionHeader .p-checkbox",
  ) as HTMLElement;
  const cloneCheckboxBox = cloneTable.querySelector(
    ".selectionHeader .p-checkbox-box",
  ) as HTMLElement;

  const syncCheckboxVisual = () => {
    if (!cloneCheckboxWrapper || !cloneCheckboxBox) return;

    const allRows = containerEl.querySelectorAll(
      ".p-datatable-tbody .p-checkbox",
    );
    const highlightedRows = containerEl.querySelectorAll(
      ".p-datatable-tbody .p-checkbox.p-highlight",
    );
    const total = allRows.length;
    const checked = highlightedRows.length;

    if (total === 0 || checked === 0) {
      cloneCheckboxWrapper.classList.remove("p-highlight");
      cloneCheckboxBox.classList.remove("p-highlight");
      cloneCheckboxBox.style.backgroundColor = "";
      cloneCheckboxBox.style.borderColor = "";
      cloneCheckboxBox.innerHTML = "";
    } else if (checked === total) {
      cloneCheckboxWrapper.classList.add("p-highlight");
      cloneCheckboxBox.classList.add("p-highlight");
      cloneCheckboxBox.style.backgroundColor = "#6366f1";
      cloneCheckboxBox.style.borderColor = "#6366f1";
      cloneCheckboxBox.innerHTML = `
				<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:14px;height:14px;display:block;">
					<path d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
						stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			`;
    } else {
      cloneCheckboxWrapper.classList.remove("p-highlight");
      cloneCheckboxBox.classList.remove("p-highlight");
      cloneCheckboxBox.style.backgroundColor = "";
      cloneCheckboxBox.style.borderColor = "";
      cloneCheckboxBox.innerHTML = "";
    }
  };

  syncCheckboxVisual();

  const tbody = containerEl.querySelector(".p-datatable-tbody") as HTMLElement;
  const observer = new MutationObserver(() => {
    requestAnimationFrame(syncCheckboxVisual);
  });
  if (tbody) {
    observer.observe(tbody, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: true,
    });
  }
  (fixedContainer as any)._checkboxObserver = observer;

  return fixedContainer;
}

function teardownSticky() {
  const existing = document.querySelector("[data-sticky-table]") as any;
  if (existing?._checkboxObserver) existing._checkboxObserver.disconnect();
  document.querySelector("[data-sticky-table]")?.remove();
}

function restoreOriginalThead(containerEl: HTMLElement | null) {
  if (!containerEl) return;
  const originalThead = containerEl.querySelector(
    ".p-datatable-thead",
  ) as HTMLElement;
  if (originalThead) {
    originalThead.style.visibility = "visible";
    originalThead.style.opacity = "1";
    originalThead.style.pointerEvents = "";
  }
}

function removeCurrentSticky() {
  teardownSticky();
  if (currentStickyId) {
    const entry = registry.get(currentStickyId);
    restoreOriginalThead(entry?.getContainerEl() ?? null);
  }
  currentStickyEl = null;
  currentStickyId = null;
  currentScrollSourceEl = null;
  currentFrozenColumnsEnabled = false; // NEW
}

function evaluate() {
  let matched: GridEntry | null = null;

  for (const entry of registry.values()) {
    const el = entry.getContainerEl();
    if (!el) continue;
    const rect = el.getBoundingClientRect();
    if (rect.top <= NAVBAR_HEIGHT && rect.bottom > NAVBAR_HEIGHT) {
      matched = entry;
      break;
    }
  }

  if (!matched) {
    if (currentStickyEl) removeCurrentSticky();
    return;
  }

  const containerEl = matched.getContainerEl();
  const scrollSourceEl = matched.getScrollSourceEl();
  if (!containerEl || !scrollSourceEl) return;

  const frozenColumnsEnabled = matched.getFrozenColumnsEnabled(); // NEW

  if (currentStickyId !== matched.id) {
    removeCurrentSticky();
    const stickyEl = createStickyHeader(
      containerEl,
      scrollSourceEl,
      frozenColumnsEnabled,
    );
    if (stickyEl) {
      currentStickyEl = stickyEl;
      currentStickyId = matched.id;
      currentScrollSourceEl = scrollSourceEl;
      currentFrozenColumnsEnabled = frozenColumnsEnabled; // NEW
      scrollSourceEl.addEventListener("scroll", handleHorizontalScroll, {
        passive: true,
      });
    }
  } else if (currentStickyEl) {
    const viewportRect = scrollSourceEl.getBoundingClientRect();
    currentStickyEl.style.left = `${viewportRect.left}px`;
    currentStickyEl.style.width = `${viewportRect.width}px`;
    currentFrozenColumnsEnabled = frozenColumnsEnabled; // NEW
    syncHorizontalScroll(
      currentStickyEl,
      containerEl,
      scrollSourceEl,
      frozenColumnsEnabled,
    );
  }
}

function handleHorizontalScroll() {
  if (!currentStickyEl || !currentStickyId || !currentScrollSourceEl) return;
  const entry = registry.get(currentStickyId);
  const containerEl = entry?.getContainerEl();
  if (!containerEl) return;
  syncHorizontalScroll(
    currentStickyEl,
    containerEl,
    currentScrollSourceEl,
    currentFrozenColumnsEnabled,
  );
}

function handleResize() {
  removeCurrentSticky();
  evaluate();
}

export function registerStickyGrid(entry: GridEntry) {
  registry.set(entry.id, entry);
  if (!scrollListenerAttached) {
    window.addEventListener("scroll", evaluate, { passive: true });
    window.addEventListener("resize", handleResize);
    scrollListenerAttached = true;
  }
}

export function unregisterStickyGrid(id: string) {
  registry.delete(id);
  if (currentStickyId === id) {
    removeCurrentSticky();
  }
  if (registry.size === 0 && scrollListenerAttached) {
    window.removeEventListener("scroll", evaluate);
    window.removeEventListener("resize", handleResize);
    if (currentScrollSourceEl) {
      currentScrollSourceEl.removeEventListener(
        "scroll",
        handleHorizontalScroll,
      );
    }
    scrollListenerAttached = false;
  }
}

export function refreshStickyGrid(id: string) {
  if (currentStickyId === id) {
    removeCurrentSticky();
  }
  evaluate();
}

export function clearStickyCheckboxHighlight() {
  requestAnimationFrame(() => {
    const stickyCheckboxWrapper = document.querySelector(
      "[data-sticky-table] .selectionHeader .p-checkbox",
    ) as HTMLElement | null;
    const stickyCheckboxBox = document.querySelector(
      "[data-sticky-table] .selectionHeader .p-checkbox-box",
    ) as HTMLElement | null;

    if (!stickyCheckboxWrapper || !stickyCheckboxBox) return;

    stickyCheckboxWrapper.classList.remove("p-highlight");
    stickyCheckboxBox.classList.remove("p-highlight");
    stickyCheckboxBox.style.backgroundColor = "";
    stickyCheckboxBox.style.borderColor = "";
    stickyCheckboxBox.innerHTML = "";
  });
}
